/* eslint-disable prettier/prettier */
<template>
  <button class="btn mb-0" :class="getClasses(variant, color, size, fullWidth, active, pulseButton)" :type="type">
    <slot />
  </button>
</template>

<script>

export default {
  name: "ArgonButton",
  props: {
    color: {
      type: String,
      default: "success",
    },
    size: {
      type: String,
      default: "md",
    },
    variant: {
      type: String,
      default: "fill",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'button',
    },
    pulse: {
      type: Boolean,
      default: false,
    },
    pulseTime: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      pulseButton: false,
      duration: 5000,
    }
  },
  mounted() {
    this.pulseButton = this.pulse;

    if (this.pulseButton) {
      this.duration = this.pulseTime;

      setTimeout(() => {
        this.pulseButton = false;
      }, this.duration);
    }
  },
  methods: {
    getClasses: (variant, color, size, fullWidth, active, pulseButton) => {
      let colorValue, sizeValue, fullWidthValue, activeValue, pulseValue;

      // Setting the button variant and color
      if (variant === "gradient") {
        colorValue = `bg-gradient-${color}`;
      } else if (variant === "outline") {
        colorValue = `btn-outline-${color}`;
      } else {
        colorValue = `btn-${color}`;
      }

      sizeValue = size ? `btn-${size}` : null;

      fullWidthValue = fullWidth ? `w-100` : null;

      activeValue = active ? `active` : null;

      pulseValue = pulseButton ? `pulse-${color}` : null;

      return `${colorValue} ${sizeValue} ${fullWidthValue} ${activeValue} ${pulseValue}`;
    },
  },
};
</script>
